<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="三选一礼包" @back="goBack" /></span>
          <el-card style="margin-top: 10px;">
            <div slot="header" class="clearfix">
              <el-row :gutter="10">
                <CommonExcel
                  ref="CommonExcelRef"
                  :import-p="'config:rewardPickOneEdit:import'"
                  :export-p="'config:rewardPickOneEdit:export'"
                  :import-method="importBaseCfg"
                  :export-method="exportBaseCfg"
                />
              </el-row>
            </div>
            <el-table size="mini" :data="baseList" border style="width: 100%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="序号" width="50">
                <template slot-scope="{row, $index}">
                  <span style="display:block">{{ $index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="最小等级" width="150">
                <template slot-scope="{row}">
                  <el-input v-model="row.minLv" placeholder="最小等级" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="最大等级" width="150">
                <template slot-scope="{row}">
                  <el-input v-model="row.maxLv" placeholder="最大等级" />
                </template>
              </el-table-column>
              <el-table-column label="用户分组" min-width="100%" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.groupIds" multiple>
                    <el-option v-for="item in groupsList" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="奖励配置" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.rewardId">
                    <el-option v-for="item in list[1]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template slot-scope="{row,$index}">
                  <el-button v-permisaction="['config:rewardPickOneEdit:del']" size="mini" type="danger" @click="deleteBaseConfig($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button v-permisaction="['config:rewardPickOneEdit:add']" type="primary" size="mini" @click="addBaseConfig()">新增</el-button>
              <el-button v-permisaction="['config:rewardPickOneEdit:add']" type="primary" :disabled="isOnline === 1" size="mini" style="margin:10px 10px" @click="handleSaveBase()">保存</el-button>
            </div>
          </el-card>
        </div>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { actAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import { getActivtyList, updateActivtyRewardConfData } from '@/api/config/activity-cfg'
import CommonExcel from '@/components/CommonExcel/index.vue'
import { downloadExcelMultiSheet } from '@/utils/excel'
export default {
  name: 'RewardPickOneEdit',
  components: { CommonExcel },
  data() {
    return {
      list: [],
      baseList: [],
      groupsList: [{ name: '默认分组', id: 0 }],
      curClass: 'pick_one',
      rewardConf: [],
      shopSku: [],
      isOnline: 0
    }
  },
  created() {
    this.aid = this.$route.query.id
    this.actType = this.$route.query.type
    this.curClass = this.$route.query.type
    this.ucType = this.$route.query.uc_type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.init()
  },
  methods: {
    init() {
      this.getActivity()
      this.getList()
      this.initBase()
    },
    initBase() {
      getUserTypeAllList().then(res => {
        res.data.forEach(res => {
          this.groupsList.push({ name: res.name, id: res.groupId })
        })
      })
    },
    getList() {
      this.loading = true
      actAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    addBaseConfig() {
      if (!this.baseList) {
        this.baseList = []
      }
      this.baseList.push({ minLv: 1, maxLv: 999, groupIds: [], rewardId: 0 })
    },
    deleteBaseConfig(index) {
      this.baseList.splice(index, 1)
    },
    handleSaveBase() {
      for (const i in this.baseList) {
        const val = this.baseList[i]
        if (!val.groupIds) {
          this.msgError('请选择分组')
          return
        }
      }
      const data = JSON.stringify(this.baseList)
      updateActivtyRewardConfData({ name: this.aid, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getActivity()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getActivity() {
      getActivtyList({ id: this.aid }).then(res => {
        if (res.code === 200) {
          let baseList = res.data.list[0].reward_conf
          if (typeof baseList === 'object' && !Array.isArray(baseList)) {
            baseList = []
          }
          this.baseList = baseList
        }
      })
    },
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    importBaseCfg(excelInfo) {
      const excelData = excelInfo.data
      for (let i = 0; i < excelData.length; i++) {
        this.baseList = this.$refs.CommonExcelRef.tranToTarget(excelData[i].sheetData, { groupIds: this.groupsList, rewardId: this.list[2] }, true, 'name', 'id')
        break
      }
    },
    exportBaseCfg() {
      const fileName = '三选一礼包配置'
      const hearer = []
      const excelData = []
      const name = ['三选一礼包配置']
      const list = this.$refs.CommonExcelRef.tranToTarget(this.baseList, { groupIds: this.groupsList, rewardId: this.list[2] }, true, 'id', 'name')
      const tAk = this.$refs.CommonExcelRef.makeExcelData(list, { minLv: '最小等级', maxLv: '最大等级', groupIds: { name: '用户分组', sub: [] }, rewardId: '奖励配置' })
      hearer.push(tAk[0])
      excelData.push(tAk[1])
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    }
  }
}
</script>

<style scoped>
</style>
